import React from 'react';

import { prepareOptionsForLocationSearch } from "../../src/js/helpers";
import TopMenu from "../SharedComponents/TopMenu";
import Footer from "../SharedComponents/Footer";

import './index.sass';


const PrivacyPage = ({ categories, footer, regions, topMenu }) => {

  const regionsOptions = prepareOptionsForLocationSearch(regions);

  return (
    <div className="privacy">
      <TopMenu
        {...topMenu}
        categories={categories}
        regionsOptions={regionsOptions}
        withSearch={true}
      />

      <div className="privacy__wrapper container">
        <h1>Selskabslokaler.dk Cookie- og privatlivspolitik</h1>

        <div className="privacy__about-us">
          <div className="privacy__about-us-title">
            Introduktion
          </div>
          <div className="privacy__about-us-content">
            <p>Velkommen til vores hjemmeside. Når du besøger os her, indsamler vi visse oplysninger for at forbedre din oplevelse og levere relevante annoncer. Hvis du foretrækker ikke at have disse oplysninger indsamlet, kan du slette dine cookies og undlade at fortsætte med at bruge hjemmesiden. Nedenfor finder du en detaljeret gennemgang af, hvilke oplysninger der indsamles, hvorfor vi gør det, og hvem der har adgang til dem.</p>
          </div>
        </div>

        <div className="privacy__about-us">
          <div className="privacy__about-us-title">
            Personoplysninger
          </div>
          <div className="privacy__about-us-content">
            <p>Generelt omfatter personlige oplysninger enhver information, der kan henføres til dig. Når du bruger vores hjemmeside, indsamler og behandler vi forskellige former for sådanne oplysninger. Dette sker ved almindelig adgang til indhold, ved tilmelding til vores nyhedsbrev, registrering som bruger eller abonnent, brug af vores tjenester, eller når du foretager køb.</p>
            <p>De typer oplysninger, vi typisk indsamler og behandler, inkluderer et unikt ID og tekniske detaljer om din enhed, din IP-adresse, geografisk placering samt hvilke sider du besøger. Hvis du giver os eksplicit samtykke og selv angiver oplysninger, kan vi også behandle navn, telefonnummer, e-mail, adresse og betalingsoplysninger, typisk i forbindelse med oprettelse af login eller ved køb.</p>
          </div>
        </div>

        <div className="privacy__about-us">
          <div className="privacy__about-us-title">
            Sikkerhed
          </div>
          <div className="privacy__about-us-content">
            <p>Vi har implementeret tekniske og organisatoriske foranstaltninger for at beskytte dine oplysninger mod uautoriseret adgang, ændring, offentliggørelse, tab, misbrug eller anden ulovlig behandling.</p>
          </div>
        </div>

        <div className="privacy__about-us">
          <div className="privacy__about-us-title">
            Formål
          </div>
          <div className="privacy__about-us-content">
            <p>Vi bruger dine oplysninger til at identificere dig som bruger, vise dig relevante annoncer, registrere dine køb og betalinger og levere de services, du efterspørger, såsom nyhedsbreve. Desuden bruger vi oplysningerne til at optimere vores tjenester og indhold.</p>
          </div>
        </div>

        <div className="privacy__about-us">
          <div className="privacy__about-us-title">
            Opbevaringstid
          </div>
          <div className="privacy__about-us-content">
            <p>Vi opbevarer oplysningerne i overensstemmelse med gældende lovgivning og sletter dem, når de ikke længere er nødvendige. Da tidspunktet for sletning afhænger af oplysningernes art og formål, kan vi ikke angive en generel tidsramme.</p>
          </div>
        </div>

        <div className="privacy__about-us">
          <div className="privacy__about-us-title">
            Deling af Oplysninger
          </div>
          <div className="privacy__about-us-content">
            <p>Vi deler visse oplysninger med tredjeparter, primært til annonceringsformål. Disse oplysninger inkluderer data om din brug af hjemmesiden, hvilke annoncer du ser eller klikker på, geografisk placering, køn og alder. Du kan se en liste over disse tredjeparter i afsnittet om cookies.</p>
            <p>Vi bruger også tredjepartstjenester til opbevaring og behandling af data, men de må kun behandle oplysninger på vores vegne og ikke til egne formål. Vi sikrer, at disse tredjeparter enten er placeret i EU eller i lande, der tilbyder tilstrækkelig beskyttelse af dine oplysninger.</p>
          </div>
        </div>

        <div className="privacy__about-us">
          <div className="privacy__about-us-title">
            Indsigtsret og Klager
          </div>
          <div className="privacy__about-us-content">
            <p>Du har ret til at få adgang til de personlige oplysninger, vi behandler om dig, og du kan til enhver tid gøre indsigelse mod vores behandling af dine oplysninger eller tilbagekalde dit samtykke. Hvis dine oplysninger er forkerte, har du ret til at få dem rettet eller slettet. Kontakt os venligst på info@selskabslokaler.dk for at udøve disse rettigheder eller for at indgive en klage til Datatilsynet.</p>
          </div>
        </div>

        <div className="privacy__about-us">
          <div className="privacy__about-us-title">
            Cookies
          </div>
          <div className="privacy__about-us-content">
            <p>Vores hjemmeside bruger cookies til at tilpasse indhold og annoncer, til sociale medier og til at analysere trafikken. Vi deler også oplysninger om din brug af vores hjemmeside med vores partnere inden for disse områder. Cookies er små tekstfiler, der kan forbedre din brugeroplevelse.</p>
            <p>Ifølge loven kan vi gemme cookies på din enhed, hvis de er nødvendige for at levere de tjenester, du har anmodet om. For andre typer cookies kræver vi dit samtykke.</p>
            <p>Du kan til enhver tid ændre eller tilbagekalde dit samtykke vedrørende cookies via vores hjemmeside.</p>
            <p>For yderligere information om vores håndtering af personoplysninger, kontakt os venligst. Dit samtykke gælder for Selskabslokaler.dk.</p>
          </div>
        </div>

        <div className="privacy__about-us">
          <div id="cookiefirst-policy-page"></div>
          <div>This cookie policy has been created and updated by <a href="https://cookiefirst.com/consent-management-platform/">Consent Management - CookieFirst</a>.</div>
        </div>

        <div className="privacy__about-us">
          <div id="cookiefirst-cookies-table"></div>
          <div>This cookie table has been created and updated by the <a href="https://cookiefirst.com/consent-management-platform/">Consent Management Platform</a>.</div>
        </div>

      </div>

      <Footer { ...footer } />
    </div>
  )
}

export default PrivacyPage;
